var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 10,
    fill: "#7F56D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14941 18V9.51562H10.8447V18H9.14941ZM10.001 8.30469C9.4541 8.30469 9.00879 7.86719 9.00879 7.32812C9.00879 6.77344 9.4541 6.35156 10.001 6.35156C10.5479 6.35156 10.9932 6.77344 10.9932 7.32812C10.9932 7.86719 10.5479 8.30469 10.001 8.30469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c7e12756be5768cb0acd53d9be826485.svg";
export { ForwardRef as ReactComponent };